module.exports = __webpack_public_path__ + "img/company_10.d7a5a5c0.png";